/* Reads the internal-staff roles out of the Keycloak token.
 *
 * This is for hiding controls only. Every endpoint enforces the same rule
 * server-side (TrackingMappingPolicy), because a token is client-side data and
 * the router has no guards at all.
 */

const INTERNAL_ROLES = ["super_admin", "user_admin"];

export type KeycloakLike = {
  tokenParsed?: {
    resource_access?: Record<string, { roles?: string[] }>;
  };
};

export const isInternalStaff = (keycloak?: KeycloakLike | null): boolean => {
  const clientId = process.env.VUE_APP_KEYCLOAK_CLIENT_ID as string;
  const roles = keycloak?.tokenParsed?.resource_access?.[clientId]?.roles ?? [];

  return INTERNAL_ROLES.some((role) => roles.includes(role));
};
